// eslint-disable-next-line
import { action, computed, makeObservable, observable, runInAction } from "mobx";
import { rootContainer, TYPE } from "../../../../services/container/root";
import PagedDataStore, { IFetchListArgs } from "../../../../stores/abstract-paged-data-store";
import ReturngoApiService from "../../../../services/api/returngo-api-service";
import ApiKeyEditorStore from "./api-key-editor-store";
import { IApiKey } from "../../../../models/IntegrationsTypes";

class ApiKeysPagedListStore extends PagedDataStore<ApiKeyEditorStore> {
	constructor() {
		super();
		makeObservable(this);
	}
    readonly perPage: number = 20;

	protected get service(): ReturngoApiService {
		return rootContainer.get<ReturngoApiService>(TYPE.ReturngoApiService);
	}

    @observable private _isPublicApiEnabled: boolean | null = null;
    @observable private _selectedApiKey?: ApiKeyEditorStore;

	@computed public get isPublicApiEnabled(): boolean {
		return this._isPublicApiEnabled === true;
	}

	@computed public get isPublicApiStatusLoaded(): boolean {
		return this._isPublicApiEnabled !== null;
	}

	@computed public get selectedApiKey(): ApiKeyEditorStore | undefined {
		return this._selectedApiKey;
	}

    @action
	public async setEditApiKey(integrationsConnectionId: number) {
		this._selectedApiKey = this.list.find(i => i.integrations_connection_id === integrationsConnectionId);
		if (!this._selectedApiKey) {
			this._isLoading = true;
			const integrationConnection = await this.service.fetchApiKey(integrationsConnectionId);
			runInAction(() => {
				this._selectedApiKey = new ApiKeyEditorStore(integrationConnection.api_key as IApiKey);
				this._isLoading = false;
			});
		}
	}

    @action
	public dropSelectedApiKey() {
		this._selectedApiKey = undefined;
	}

	protected async fetchList(args: IFetchListArgs) {
		const result = await this.service.fetchList(args);
		runInAction(() => {
			this._isPublicApiEnabled = !!result.is_public_api_enabled;
		});
		return {
			...result.list,
			data: result.list.data.map(integration => new ApiKeyEditorStore(integration.api_key as IApiKey))
		};
	}

    public async removeApiKey(integrationsConnectionId: number) {
        this._isLoading = true;
        try {
            await this.service.removeApiKey(integrationsConnectionId); 
            await this.loadPage(1);
            runInAction(() => {
                this._isLoading = false;
            });
        } catch(e) {
            runInAction(() => {
                this._isLoading = false;
            });
        }
    }

    public async addApiKey() {
        if (!this.isPublicApiEnabled) {
            return;
        }
        this._isLoading = true;
        try {
            await this.service.addApiKey();
            await this.loadPage(1);
            runInAction(() => {
                this._isLoading = false;
            });
        } catch(e) {
            runInAction(() => {
                this._isLoading = false;
            });
        }
    }
}

export default new ApiKeysPagedListStore();
